







import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import AsiToolbar from "@/components/common/AsiToolbar.vue";
import AsiContentContainer from "@/components/common/AsiContentContainer.vue";
import {Icon} from "@/helpers/icons";
import PlanningEntryList from "@/components/planningEntry/PlanningEntryList.vue";
import PlanningEntryListFilter from "@/models/planningEntry/PlanningEntryListFilter";
import {toISODateString} from "@/helpers/functions_asi";

@Component({
	components: {PlanningEntryList, AsiContentContainer, AsiToolbar}
})
export default class DriversNextOrders extends Vue {

	@Prop({type: String, required: true})
	public userId!: string | null;

	private icons = Icon;
	private filter: PlanningEntryListFilter | null = null;

	public created(): void {
		this.filter = new PlanningEntryListFilter();
		this.filter.userId = this.userId;
		this.filter.dateFrom = toISODateString(new Date());
	}

}
